import {
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { searchApiRef } from '@backstage/plugin-search-react';
import { SearchClient, semanticSearchApiRef } from './api';
import { SemanticSearchClient } from '@appfolio/backstage-plugin-search-common';

export const searchPlugin = createPlugin({
  id: 'appfolio-search',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: semanticSearchApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new SemanticSearchClient({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: searchApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new SearchClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const SearchPage = searchPlugin.provide(
  createRoutableExtension({
    name: 'SearchPage',
    component: () =>
      import('./components/page/SearchPage').then(m => m.SearchPage),
    mountPoint: rootRouteRef,
  }),
);

export const SidebarSearch = searchPlugin.provide(
  createComponentExtension({
    name: 'SidebarSearch',
    component: {
      lazy: () =>
        import('./components/SidebarSearch').then(m => m.SidebarSearch),
    },
  }),
);

export const HomePageSearchBar = searchPlugin.provide(
  createComponentExtension({
    name: 'HomePageSearchBar',
    component: {
      lazy: () =>
        import('./components/HomePageSearchBar').then(m => m.HomePageSearchBar),
    },
  }),
);

export const SearchResultList = searchPlugin.provide(
  createComponentExtension({
    name: 'SearchResultList',
    component: {
      lazy: () =>
        import('./components/SearchResultList').then(m => m.SearchResultList),
    },
  }),
);

export const SearchIcon = searchPlugin.provide(
  createComponentExtension({
    name: 'SearchIcon',
    component: {
      lazy: () => import('./components/SearchIcon').then(m => m.SearchIcon),
    },
  }),
);
